import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Downshift from 'downshift';
import IconMore from '@components/icons/IconMore';

function MoreButton<T extends readonly string[]>({
  items,
  className,
  onSelect,
}: {
  items: T;
  className?: string;
  onSelect: (val: T[number]) => void;
}) {
  const [pos, setPos] = useState({ left: 0, top: 0 });

  return (
    <Downshift onSelect={onSelect}>
      {({ getToggleButtonProps, getItemProps, getMenuProps, isOpen }) => (
        <div
          className={className}
          {...getToggleButtonProps({
            onClick: (e) => {
              e.stopPropagation();
              const node = e.target as HTMLElement;
              const rect = node.getBoundingClientRect();
              setPos({
                left: rect.left + 5,
                top: rect.top - items.length * 30,
              });
            },
          })}
        >
          <IconMore />
          {isOpen &&
            createPortal(
              <div
                className="absolute z-30 select-none overflow-hidden rounded bg-white text-base text-black focus:outline-none"
                style={pos}
                {...getMenuProps()}
              >
                {items.map((item, index) => (
                  <div
                    className="flex h-30 cursor-pointer items-center justify-center px-10 hover:bg-white-light"
                    key={item}
                    {...getItemProps({
                      item,
                      index,
                      onClick: (e) => {
                        e.stopPropagation();
                      },
                    })}
                  >
                    {item}
                  </div>
                ))}
              </div>,
              document.body
            )}
        </div>
      )}
    </Downshift>
  );
}

export default MoreButton;
